// frontend/src/pages/PayrollItems/components/RadioOpt.tsx
// Shared radio option. Used by PayTypesBody and LocationsBody for the
// Active/Inactive segmented control.

import React from "react";
import { BRAND, TEXT_PRIMARY, TEXT_TERTIARY } from "../styles";

interface RadioOptProps {
  label: string;
  /** Whether this option is currently selected. */
  on: boolean;
  onClick: () => void;
}

export default function RadioOpt({
  label,
  on,
  onClick,
}: RadioOptProps): React.ReactElement {
  return (
    <span
      onClick={onClick}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 8,
        fontSize: 14,
        fontWeight: 500,
        color: TEXT_PRIMARY,
        cursor: "pointer",
      }}
    >
      <span
        style={{
          width: 18,
          height: 18,
          borderRadius: "50%",
          border: "1.6px solid " + (on ? BRAND : TEXT_TERTIARY),
          display: "grid",
          placeItems: "center",
        }}
      >
        {on && (
          <span
            style={{
              width: 9,
              height: 9,
              borderRadius: "50%",
              background: BRAND,
            }}
          />
        )}
      </span>
      {label}
    </span>
  );
}